/// <amd-module name="Wit/Identity/Constants/Constants" />
export namespace SubjectType {
    export const AadUser = "aad";
    export const AadGroup = "aadgp";
    export const AadServicePrincipal = "aadsp";
}